'use strict';

exports.__esModule = true;

var _reactRouter = require('react-router');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _reactRouter.matchPath;
  }
});


//////////////////
// WEBPACK FOOTER
// ./~/gatsby/~/react-router-dom/matchPath.js
// module id = ./node_modules/gatsby/node_modules/react-router-dom/matchPath.js
// module chunks = 2